import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import Price from '@/components/price/index.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import { insteadPrintProductList, getRfidInfo } from '@/services/http';
import { readCookie } from '@/tools/tools';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.loading = false;
    // 热门推荐列表
    _this.recommendList = [];
    // 有无数据
    _this.isNodata = false;
    // 当前页数
    _this.currentpage = 1;
    // 总条数
    _this.totalnumber = 0;
    _this.pageNo = 1;
    _this.pageSize = 10;
    _this.keywords = '';
    _this.typeName = '';
    // 规格尺寸列表
    _this.sizeList = [];
    _this.dialogVisible = false;
    // 所选规格尺寸
    _this.size = '';
    _this.orderNum = '';
    // 所选规格index
    _this.sizeCurrentIndex = -1;
    _this.productId = '';
    _this.title = '';
    // 访问页面数据埋点
    // private pageVisit() {
    //   const anchor = readCookie('anchor');
    //   pageVisit({
    //     pageType: 2,
    //     equip: anchor ? anchor.equip : 4,
    //     version: anchor ? anchor.version : '',
    //     src: anchor ?(anchor.src?anchor.src:2):4,
    //     model: anchor ? anchor.model : '',
    //     equipVersion: anchor ? anchor.equipVersion : '',
    //     equipMeid: anchor ? anchor.equipMeid : ''
    //   });
    // }
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.getProductList();
    }
    // @Watch('$route')
    // routechange() {
    //   this.getProductList();
    // }
  }, {
    key: "goDetails",
    value: function goDetails(id) {
      this.$router.push("/consumables-details?id=".concat(id, "&from=details"));
    }
    // 获取商品分页列表
  }, {
    key: "getProductList",
    value: function () {
      var _getProductList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var anchor, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              anchor = readCookie('anchor');
              this.keywords = this.$route.query.keyword ? String(this.$route.query.keyword) : '';
              this.loading = true;
              _context.next = 5;
              return insteadPrintProductList({
                keyword: this.$route.query.keyword,
                productTypeId: this.$route.query.productTypeId ? this.$route.query.productTypeId : '',
                // parentTypeId: this.$route.query.parentTypeId
                //   ? this.$route.query.parentTypeId
                //   : '',
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                model: anchor ? anchor.model : '',
                equipMeid: anchor ? anchor.equipMeid : '',
                src: anchor ? anchor.src ? anchor.src : 2 : 4,
                equip: anchor ? anchor.equip : 4,
                version: anchor ? anchor.version : '',
                companyId: 1
              });
            case 5:
              res = _context.sent;
              if (res.data.code === 100) {
                this.recommendList = res.data.data.list;
                this.typeName = res.data.data.list.length !== 0 ? res.data.data.list[0].typeStr : '';
                this.totalnumber = res.data.data.total;
                this.isNodata = this.recommendList.length === 0;
              } else {
                this.$message.error(res.data.message);
              }
              this.loading = false;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getProductList() {
        return _getProductList.apply(this, arguments);
      }
      return getProductList;
    }()
  }, {
    key: "handleCurrentChange",
    value: function handleCurrentChange(val) {
      this.pageNo = val;
      this.getProductList();
    }
  }, {
    key: "handleSizeChange",
    value: function handleSizeChange(val) {
      this.pageSize = val;
      this.getProductList();
    }
  }, {
    key: "getProductSize",
    value: function () {
      var _getProductSize = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(id, name) {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.dialogVisible = true;
              _context2.next = 3;
              return getRfidInfo({
                productId: id
              });
            case 3:
              res = _context2.sent;
              this.sizeList = res.data.data;
              this.productId = id;
              this.title = name;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getProductSize(_x, _x2) {
        return _getProductSize.apply(this, arguments);
      }
      return getProductSize;
    }() // 选择规格尺寸
  }, {
    key: "selectSize",
    value: function selectSize(size, index) {
      this.size = size;
      this.sizeCurrentIndex = index;
    }
    // 下一步
  }, {
    key: "next",
    value: function next() {
      var materialName = this.$route.query.materialName;
      if (this.size === '') {
        this.$message.error('请选择尺寸');
      } else if (this.orderNum === '') {
        this.$message.error('请输入定制张数');
      } else {
        this.$router.push("/erial-infor?size=".concat(this.size, "&orderNum=").concat(this.orderNum, "&productId=").concat(this.productId, "&materialName=").concat(materialName));
      }
    }
  }, {
    key: "save",
    value: function save() {
      if (this.size === '') {
        this.$message.error('请选择尺寸');
      } else if (this.orderNum === '') {
        this.$message.error('请输入定制张数');
      } else {
        this.dialogVisible = false;
      }
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Price: Price,
    Footer: Footer,
    BackTop: BackTop
  }
})], default_1);
export default default_1;